/*
 * ActionTrackerOverview.tsx
 * Author: fwunderlich
 * Date: 23.05.2024
 *
 * Copyright: DMT GmbH & Co. KG
 */
import React, {useEffect, useState} from 'react';
import {useGetActionTrackerQuery} from '../../../redux/rtk/injectedActionTrackerApi';
import {Button} from 'primereact/button';
import {Menu} from 'primereact/menu';
import {CustomConfirmDialog} from '../../global/CustomConfirmDialog';
import {checkPermission} from '../../../functions/functionLibrary';
import {permissions} from '../../../config/permissions';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPerson, faProjectDiagram} from '@fortawesome/free-solid-svg-icons';
import {getFiltersPerson} from '../../functions/GlobalData';
import CustomDataTable from '../../global/CustomDataTable';
import {useTranslation} from 'react-i18next';
import {getColumnsActionTracker, getFiltersActionTracker} from '../../functions/Management';
import {useNavigate} from 'react-router-dom';

type Props = { projectId: string }

export const ActionTrackerOverview = (props: Props) => {
    const {t} = useTranslation(['common']);
    const navigate = useNavigate();

    const [dataLoaded, setDataLoaded] = useState<boolean>(false);
    const [actionTracker, setActionTracker] = useState<any[]>([]);

    const {data: actionTrackerData = undefined} = useGetActionTrackerQuery({projectId: props.projectId});

    useEffect(() => {
        console.log(actionTrackerData);
        if (actionTrackerData) {

            let temp = JSON.parse(JSON.stringify(actionTrackerData));

            for (let i = 0; i < temp.length; i++) {

                for (let j = 0; j < Object.keys(temp[i]).length; j++) {
                    let key = Object.keys(temp[i])[j];
                    let value = temp[i][key];

                    if (value == null) {
                        temp[i][key] = '';
                    }
                }
            }

            setActionTracker(temp);

            setDataLoaded(true);
        }
    }, [actionTrackerData]);

    return <CustomDataTable
        id="actionTrackerDataTable"
        header={t('actionTracker:singular')}
        columns={getColumnsActionTracker(t)}
        customButtons={[{
            icons: [{key: null, value: null, icon: <FontAwesomeIcon icon={faProjectDiagram}/>}],
            tooltip: t('edit'),
            tooltipOptions: {position: 'top'},
            onClick: (data: any) => {
                const url = `/project/${props.projectId}/#globalData_0_${data['vorgang_id']}`;

                navigate(url);
            },
            permitted: true,
        }]}
        editable={false}
        sortable={true}
        value={actionTracker}
        paginator={true}
        paginatorHideAll={true}
        filters={getFiltersActionTracker()}
        dataloaded={dataLoaded}
        displayColumnFilter={true}
    />;
};
